import { useDispatch } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";

import sessionSlice from "./Session/SessionSlice";

export const store = configureStore({
    reducer: {
        session: sessionSlice.reducer
    },
});

export type AppDispatch = typeof store.dispatch
export const useAppDispatch = () => useDispatch<AppDispatch>()
export type RootState = ReturnType<typeof store.getState>